import { StreamActions } from '@hotwired/turbo'

StreamActions.redirect = function() {
  const url = this.getAttribute('url') || '/'

  if (url) Turbo.visit(url)
}
